module.exports = __webpack_public_path__ + "static/media/view_my_profile_button.f6a573a2.mp3";